module.exports = __webpack_public_path__ + "static/media/Timesheet card.77c41007.png";